import dayjs from 'dayjs';
import advanced from 'dayjs/plugin/advancedFormat';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

const useDayjs = () => {
  dayjs.extend(relativeTime);
  dayjs.extend(utc);
  dayjs.extend(advanced);
  dayjs.extend(timezone);
  dayjs.extend(isBetween);

  return dayjs;
};

export default useDayjs;
